export default "__VITE_ASSET__2gCmdQUB__"